<template>
  <div>
    You have been logged out. Click Login on the menu bar to log in again
  </div>
</template>
<script>
// import Welcome from '../../coreui/components/Welcome'
export default {
  components: {
    // Welcome
  },
  mounted () {
    var self = this
    setTimeout(function() {
      // self.$router.replace('/Welcome')
    }, 1000)
  }
}
</script>